import { useGetUser, useTeamInfo } from 'src/hooks';
import { AppRoutes, UserSettingsNestedRoutes } from 'src/types';
import { Cube, Users } from '@phosphor-icons/react';
import React from 'react';
import { SVG_SIZE_M } from 'src/constants';
import { NavigationItem } from 'src/v2/components/LeftSidePanel/components/UserMenuSection/components/NavigationItem';

export const SubscriptionButtons = () => {
  const { isTeamsTier } = useGetUser();
  const { isAdmin, isOwner } = useTeamInfo();
  const buttons = [
    {
      disabled: false,
      title: 'Subscription',
      route: `${AppRoutes.MANAGE_ACCOUNT}/${UserSettingsNestedRoutes.SUBSCRIPTION}`,
      icon: <Cube size={SVG_SIZE_M} />,
      isVisible: true,
    },
    {
      disabled: !(isAdmin || isOwner),
      title: 'Manage users',
      route: `${AppRoutes.MANAGE_ACCOUNT}/${UserSettingsNestedRoutes.MANAGE_USERS}`,
      icon: <Users size={SVG_SIZE_M} />,
      isVisible: isTeamsTier,
    },
  ];

  return (
    <>
      {buttons.map((button) => (
        <NavigationItem key={button.route} item={button} />
      ))}
    </>
  );
};
